import { paginationParam } from 'shared/constant';

import {
  SET_LIST_ORDER,
  PROCESSING,
  PROCESSING_CSV,
  SET_ALL_LIST_ORDER,
  GET_SINGLE_ORDER,
  GET_SINGLE_ORDER_SUCCESS,
  GET_SINGLE_ORDER_FAILED,
  GET_SINGLE_ORDER_STATUS,
  GET_SINGLE_ORDER_STATUS_SUCCESS,
  GET_SINGLE_ORDER_STATUS_FAILED,
  SET_LIST_PARTNER,
  SET_PARTNER_DETAIL,
  UPDATE_PARTNER,
  UPDATE_PARTNER_EDIT_STEP,
  SET_LIST_CLIENT,
  SET_GET_CLIENT_DETAILS_LOADING,
  SET_CLIENT_DETAILS,
  SET_CREATE_NEW_CLIENT_LOADING,
  SET_REVOKE_CLIENT_LOADING,
  SET_REFRESH_CLIENT_LOADING,
  INIT_PARTNER_EDIT,
} from '../actions/types';

export const initialState = {
  loading: false,
  loadingCSV: false,
  orderListFilter: paginationParam,
  listOrder: [],
  dataCSV: {},
  partnerList: [],
  partnerFilter: paginationParam,
  partnerDetail: {},
  getPartnerDetailLoading: false,
  partnerEditStep: 1,
  clientList: [],
  clientFilter: paginationParam,
  clientDetails: {},
  getClientDetailsLoading: false,
  createNewClientLoading: false,
  revokeClientLoading: false,
  refreshClientLoading: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case PROCESSING:
    case GET_SINGLE_ORDER:
    case GET_SINGLE_ORDER_STATUS:
      return {
        ...state,
        loading: true,
      };
    case SET_LIST_ORDER:
      return {
        ...state,
        listOrder: action.payload,
        loading: false,
        orderListFilter: action.filter,
      };
    case PROCESSING_CSV:
      return {
        ...state,
        loadingCSV: true,
      };
    case SET_ALL_LIST_ORDER:
      return {
        ...state,
        loadingCSV: false,
        dataCSV: action.payload,
      };
    case GET_SINGLE_ORDER_SUCCESS:
    case GET_SINGLE_ORDER_FAILED:
    case GET_SINGLE_ORDER_STATUS_SUCCESS:
    case GET_SINGLE_ORDER_STATUS_FAILED:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    case SET_LIST_PARTNER:
      return {
        ...state,
        partnerList: action.payload,
        loading: false,
        partnerFilter: action.filter,
      };
    case SET_PARTNER_DETAIL:
      return {
        ...state,
        partnerDetail: action.payload,
        loading: false,
        getPartnerDetailLoading: false,
      };
    case UPDATE_PARTNER:
      return {
        ...state,
        loading: false,
      };
    case SET_LIST_CLIENT:
      return {
        ...state,
        clientList: action.payload,
        loading: false,
        clientFilter: action.filter || paginationParam,
      };
    case SET_GET_CLIENT_DETAILS_LOADING:
      return {
        ...state,
        getClientDetailsLoading: action.loading,
      };
    case SET_CLIENT_DETAILS:
      return {
        ...state,
        clientDetails: action.client,
        getClientDetailsLoading: false,
      };
    case SET_CREATE_NEW_CLIENT_LOADING:
      return {
        ...state,
        createNewClientLoading: action.loading,
      };
    case SET_REVOKE_CLIENT_LOADING:
      return {
        ...state,
        revokeClientLoading: action.loading,
      };
    case SET_REFRESH_CLIENT_LOADING:
      return {
        ...state,
        refreshClientLoading: action.loading,
      };
    case UPDATE_PARTNER_EDIT_STEP: {
      return {
        ...state,
        partnerEditStep: action.step,
      };
    }
    case INIT_PARTNER_EDIT: {
      return {
        ...state,
        partnerEditStep: 1,
        getPartnerDetailLoading: true,
        partnerDetail: initialState.partnerDetail,
      };
    }
    default:
      return state;
  }
}
